/**
 * /tenants/$slug/directory/ad-inbound/new — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AdInboundSetupPage } from "@/features/directory/pages/ad-inbound-setup-page";

export const Route = createFileRoute("/_authed/tenants/$slug/directory/ad-inbound/new")({
  component: AdInboundSetupPage,
});
